import { Divider, Flex, Text } from '@chakra-ui/react';

type Props = {
  title: string;
  subTitle?: string;
};

export const NavigationUserMenuHeader = ({ title, subTitle }: Props) => {
  return (
    <Flex flexDir='column' px={6} pt={2}>
      <Text variant='heading6'>{title}</Text>
      {subTitle && subTitle.length > 0 && (
        <Text variant='label' color='neutral400' noOfLines={1}>
          {subTitle}
        </Text>
      )}
      <Divider mb={2} mt={3} />
    </Flex>
  );
};
